<template>
  <div class="dn-top-messages" v-if="isExist">
    <p
      v-for="(message, index) in messages"
      :key="index"
      :class="message.className || ''"
      v-html="message.body"
    ></p>
  </div>
</template>



<script>
export default {
  name: 'dn-top-messages',

  computed: {
    messages() { return this.$store.getters['notices/notices'] },
    isExist() { return this.$store.getters['notices/exist'] },
  },
}
</script>



// WEBPACK FOOTER //
// TopMessages.vue?d6229334